import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import ManageOrdonnanceLunette from '@/views/consultations/en-cours/ophtalmologie/ordonnance-lunettes/manage-ordonnance-lunettes'
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

export default {
    name: 'ordonnance-lunettes',
    components: {
        ManageOrdonnanceLunette, EnteteBonEtFacture
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },

    data() {
        return {
            is_loading: true,
            is_empty: false,
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_ordonnances: [],
            selected_ordonnance: [],
            data_to_be_deleted: {},

            can_print: false
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()
        }
    },

    computed: {
        can_print_ordl() {
            return this.$store.getters['can_print_ordl']
        }, 
    },

    mounted() {
        this.userInfoSetter()

        const t = new Date()
        this.filename = 'Ordonnance de lunettes_'+t.getTime()

        this.$store.commit("SET_CAN_PRINT_ORDL", false)
        this.$store.commit("SET_ORDONNACE_LUNETTES_TO_PRINT", {})
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        getData() {
            this.$store.commit("SET_CAN_PRINT_ORDL", false)
            this.is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: 'ordonnance_lunettes',
                est_en_cours: true
            }

            store_fiche.getCustomConsultationSectionData(data).then((response) => {
                this.list_ordonnances = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                
                this.is_loading = false
            })
        },

        addNew() {
            this.group_id = 0
            this.selected_ordonnance = []
            
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#ordl-'+this.evolution_id).modal('show')
        },

        editOrdonnance(data) {
            this.group_id = data.group_service_id
            this.selected_ordonnance = data.fields

            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#ordl-'+this.evolution_id).modal('show')
        },

        removeOrdonnance(data) {
            this.data_to_be_deleted = {
                libelle: data.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: 'ordonnance_lunettes'
            }

            $('.del-grp-ordl'+this.evolution_id).modal('show')
        },

        printOrdl(data) {
            this.$store.commit("SET_CAN_PRINT_ORDL", true)
            this.$store.commit("SET_ORDONNACE_LUNETTES_TO_PRINT", data)
        },
    }
}